var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionWarningYellowColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4592 4.84118C10.7963 4.31692 11.3768 4 12 4C12.6232 4 13.2037 4.31691 13.5408 4.84118L21.7545 17.6181C21.9148 17.8674 22 18.1576 22 18.454C22 19.3079 21.3079 20 20.454 20H3.54595C2.69215 20 2 19.3079 2 18.454C2 18.1576 2.08523 17.8674 2.24553 17.6181L10.4592 4.84118Z",
    fill: "url(#paint0_linear_2227_16519)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8H11V14H13V8Z",
    fill: "#444140"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H11V18H13V16Z",
    fill: "#444140"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2227_16519",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC30D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionWarningYellowColored);
export default __webpack_public_path__ + "static/media/ic_action_warning_yellow_colored.830bd8aeef3be5fe21e8389fb6a93dc5.svg";
export { ForwardRef as ReactComponent };